module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-MediumCn.3b37becc.woff";